export const METHODS = {
    Cash: 1,
    Card: 2,
    Balance: 3,
};

export const METHODS_STRING = {
    [METHODS.Cash]: 'Безналичный счет',
    [METHODS.Card]: 'Банковская карта, СБП',
    [METHODS.Balance]: 'Баланс',
};

export const BTN_NAME = {
    [METHODS.Cash]: 'Сформировать счет',
    [METHODS.Card]: 'Перейти к оплате',
    [METHODS.Balance]: 'Купить'
}


// WEBPACK FOOTER //
// ./src/modules/home/tariffBuy/constants.js